import { queryClient } from '@/services/api/queryClient'
import { isLoggedIn } from '@/features/Auth/session/utils'

const TIMEOUT = 5 * 60 * 1000

/**
 * Resolves once somebody is signed in with a profile this server knows.
 *
 * The gate used to wait on `ensureLoggedInTopic`, which every path through signing in had to
 * remember to publish — four call sites, and one forgotten publish would hang whatever was
 * waiting with nothing on screen to explain it. This watches the query cache instead, so it
 * fires however the profile got there, including a signup writing it straight in. Signing in
 * no longer has to announce itself for a gate elsewhere to notice. See EPIC-005.
 */
export function awaitSignedIn(timeout = TIMEOUT): Promise<boolean> {
  if (isLoggedIn()) return Promise.resolve(true)

  return new Promise(resolve => {
    const settle = (value: boolean) => {
      clearTimeout(timer)
      unsubscribe()
      resolve(value)
    }

    const timer = setTimeout(() => settle(false), timeout)
    const unsubscribe = queryClient.client.getQueryCache().subscribe(() => {
      if (isLoggedIn()) settle(true)
    })
  })
}
